<div style="width: 100%;text-align: right!important;">
                    {{currentValue}}
                    </div>